export default __webpack_public_path__ + "0b5fe5a8b1187cc8e177aea2658b02c5.png";